import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError("Les deux mots de passe ne correspondent pas.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Mot de passe réinitialisé. Vous pouvez vous connecter.");
      navigate("/login");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-bg flex min-h-screen items-center justify-center px-4">
      <div className="w-full max-w-md rounded-xl bg-card p-8 shadow-2xl">
        <h2 className="font-display text-xl font-semibold">Nouveau mot de passe</h2>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label>Nouveau mot de passe (8 caractères min.)</Label>
            <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" data-testid="reset-password-input" />
          </div>
          <div>
            <Label>Confirmer le mot de passe</Label>
            <Input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1.5" data-testid="reset-confirm-input" />
          </div>
          {error && <p className="text-sm text-destructive" data-testid="reset-error">{error}</p>}
          <Button type="submit" disabled={loading || !token} className="w-full" data-testid="reset-submit-button">
            {loading ? "Réinitialisation…" : "Réinitialiser"}
          </Button>
          <Link to="/login" className="block text-center text-sm text-muted-foreground hover:text-foreground">Retour à la connexion</Link>
        </form>
      </div>
    </div>
  );
}
